module.exports = __webpack_public_path__ + "img/logo-sd-india.72a50df5.png";